module.exports = __webpack_public_path__ + "img/coin_background.b5877178.png";